.codeBlock {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  overflow-x: auto;
  margin: 16px 0;
}

.inlineCode {
  background-color: #f5f5f5;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 0.875em;
}

.tableWrapper {
  overflow-x: auto;
  margin: 16px 0;
  border-radius: 8px;
  border: 1px solid var(--box-border-color, #e0e0e0);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9375rem;
  background: var(--main-background, white);
}

.thead {
  background: var(--white-blue, rgba(138, 187, 255, 0.15));
  border-bottom: 2px solid var(--main-blue, #4c90f0);
}

.th {
  text-align: left;
  padding: 10px 12px;
  font-weight: 600;
  color: var(--main-blue, #4c90f0);
}

.table tbody tr:nth-child(even) {
  background: var(--light-grey, #f6f7f9);
}

.tr {
  border-bottom: 1px solid var(--box-border-color, #e8e8e8);
}

.tr:last-child {
  border-bottom: none;
}

.td {
  padding: 10px 12px;
  vertical-align: top;
  color: var(--body-text, #555);
  border-right: 1px solid var(--box-border-color, #e8e8e8);
}

.td:last-child {
  border-right: none;
}
